import script from "./BookingForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingForm.vue?vue&type=script&setup=true&lang=js"

import "./BookingForm.vue?vue&type=style&index=0&id=26bf6769&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\rcpetresort.com\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26bf6769"]])

export default __exports__